import { faqs } from '@/lib/content'
import {
  ADDRESS,
  DEFAULT_DESCRIPTION,
  INSTAGRAM_URL,
  SITE_CNPJ,
  SITE_EMAIL,
  SITE_LEGAL_NAME,
  SITE_NAME,
  SITE_URL,
  TELEGRAM_URL,
  WHATSAPP_DISPLAY,
} from '@/lib/site'

const geo = {
  '@type': 'GeoCoordinates',
  latitude: -19.9388,
  longitude: -43.9281,
}

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  legalName: SITE_LEGAL_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/favicon.svg`,
  email: SITE_EMAIL,
  telephone: WHATSAPP_DISPLAY,
  taxID: SITE_CNPJ,
  foundingDate: '2019',
  sameAs: [INSTAGRAM_URL, TELEGRAM_URL],
  address: {
    '@type': 'PostalAddress',
    streetAddress: ADDRESS.street,
    addressLocality: ADDRESS.city,
    addressRegion: ADDRESS.state,
    postalCode: ADDRESS.postalCode,
    addressCountry: ADDRESS.country,
  },
}

export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: SITE_LEGAL_NAME,
  image: `${SITE_URL}/favicon.svg`,
  url: SITE_URL,
  telephone: WHATSAPP_DISPLAY,
  email: SITE_EMAIL,
  taxID: SITE_CNPJ,
  priceRange: '$$',
  description: DEFAULT_DESCRIPTION,
  address: organizationSchema.address,
  geo,
  areaServed: 'BR',
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '09:00',
    closes: '18:00',
  },
}

export const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.a.join(' '),
    },
  })),
}
